import * as React from 'react';
import { BasicTab } from 'ui-lib/components/tab/basic-tab';
import { LevelsAndRolesMatrixPage } from './levels-roles-matrix';
import { RolesAndPermissionsMatrixPage } from './roles-permissions-matrix';
import { useSearchParams } from 'react-router-dom';
import { useStores } from 'store';
import { IRole } from 'dto/access-management/user-role-dto';
import { PermissionProvider } from 'contexts/permissions/permission-provider';

enum TYPES {
    ROLE = 'role',
    PERMISSION = 'permission',
}

interface IManageRolePermissionContext {
    getDisplayRoleName: (role: IRole, displayKey?: 'name' | 'roleType') => string;
}
const ManageRolePermissionContext = React.createContext<IManageRolePermissionContext>(null);
export const useManageRolePermissionContext = () => React.useContext<IManageRolePermissionContext>(ManageRolePermissionContext);

export const UserRolePermissionsPage = (): JSX.Element => {
    const [searchParams, setSearchParams] = useSearchParams();
    
    const { authStore } = useStores();
    const getDisplayRoleName = React.useMemo(() => {
        if (!authStore.isDPUAdmin) {
            return (role: IRole, displayKey: 'name' | 'roleType' = 'name'): string => role[displayKey];
        }
        return (role: IRole, displayKey: 'name' | 'roleType' = 'name'): string => {
            if (role.account) {
                return `${role[displayKey]} (${role.account.name})`;
            }
            return role[displayKey];
        };
    }, [authStore.isDPUAdmin]);

    return (
        <PermissionProvider groups={['Admin']}>
            <ManageRolePermissionContext.Provider value={{ getDisplayRoleName }}>
                <BasicTab
                    defaultActiveIndex={searchParams.get('type') ?? TYPES.ROLE}
                    onChange={(key) => setSearchParams({ type: key })}
                    tabPanes={[
                        {
                            label: 'Levels vs Roles Matrix',
                            key: TYPES.ROLE,
                            pane: <LevelsAndRolesMatrixPage />,
                        },
                        {
                            label: 'User Roles Permissions Matrix',
                            key: TYPES.PERMISSION,
                            pane: <RolesAndPermissionsMatrixPage />,
                        },
                    ]}
                />
            </ManageRolePermissionContext.Provider>
        </PermissionProvider>
    );
};
